// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1_Lq_","cls2":"Cta-cls2__w4 Cta-cls1_Lq_"};